// extracted by mini-css-extract-plugin
export default {"youtube_url":"Elements_youtube_url__Dv91X"};